import React, { Component } from 'react';
import imgApproach from '../images/ems-approach.png';
import '../css/imgStyles.css';

class Approach extends Component {
    
    render() {
      return (
        <React.Fragment>
            <p id="title">EMS Approach</p>
            <div className="imgDivStyle fadeInStyle">
                <img src={imgApproach} />
            </div>

        </React.Fragment>
      );
   }
}

export default Approach;